module.exports = __webpack_public_path__ + "img/code-bg.76c021aa.png";